export default "__VITE_ASSET__DdI7f57p__"